import React from 'react';
import style from './Navbar.module.scss';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';
import { logout } from '@multiversx/sdk-dapp/utils';
import { ReactComponent as TadaLogo } from 'src/assets/brand/logo.svg';
import { ReactComponent as TadaLogoOnly } from 'src/assets/brand/logo-only.svg';
import { ReactComponent as MultiversXIcon } from 'src/assets/icons/multiversx.svg';
import { ReactComponent as LogoutIcon } from 'src/assets/icons/logout.svg';
import { ReactComponent as RightArrowIcon } from 'src/assets/icons/arrow-right.svg';
import { Link, useLocation } from 'react-router-dom';
import { breakpoints, useBreakpoints } from 'src/hooks/useBreakpoints';

const Navbar = () => {
    const { account } = useGetAccountInfo();
    const isConnected = account && account.address;
    const isMobile = useBreakpoints(breakpoints.xs);
    const location = useLocation();
    const isConnectWalletPage = location.pathname === '/connect-wallet';

    const handleLogout = async () => {
        await logout();
        window.location.href = '/connect-wallet';
    };

    const shortenAddress = (address) => {
        if (!address) return '';
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    };

    return (
        <nav className={style.navbar}>
            <Link to="/">{isMobile ? <TadaLogoOnly /> : <TadaLogo />}</Link>
            <div className={style.items}>
                {!isMobile && <span className={style.status}>MultiversX</span>}
                {isConnected ? (
                    <>
                        <span className={style.account}>{shortenAddress(account.address)}</span>
                        <button className={style.logout} onClick={handleLogout}>
                            <LogoutIcon />
                        </button>
                    </>
                ) : (
                    <>
                        {!isConnectWalletPage && (
                            <Link to="/connect-wallet" className={style.connectButton}>
                                <MultiversXIcon /> Connect Wallet <RightArrowIcon />
                            </Link>
                        )}
                    </>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
